import React, { useState } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Login from "./pages/Login/index";
import MainPanel from "./pages/Home/index";
import NoPage from "./pages/NoPage/index";
import { AuthProvider } from "./context/AuthContext";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Spinner from "./components/Loaders";
import { LoadingProvider } from "./context/LoadingContext"; // Import the LoadingProvider
import { SearchResultsProvider } from "./context/SearchResultsContext";
import "react-tooltip/dist/react-tooltip.css";
import LabCenter from "./pages/LabCenter.js";
import ToxPage from "./pages/ToxReport/index.js";
import BloodReport from "./pages/BloodReport/index.js";
import StiReport from "./pages/StiReport/index.js";
import SidebarComponent from "./components/Sidebar.js";
import LabCompilance from "./pages/LabCompilance/index.js";
import Header from "./components/Header.js";
import PrivateRoute from "./pages/PrivateRoute.js";
import PatientDashobard from "./pages/PatientDashobard/index.js";
import PatientList from "./pages/PatientList/index.js";
import SearchPatientHeader from "./components/SearchPatientHeader.js";
import { PatientDemographyProvider } from "./context/DempgraphicContext.js";

const App = () => {
  const location = useLocation();
  const [open, setIsOpen] = useState(true);
  return (
    <div className={`h-screen ${location.pathname === "/login" ? "" : "flex"}`}>

      <div
        className={`flex-1 flex flex-col ${location.pathname === "/login" ? "" : "bg-gray-100"}`}
      >
        {location.pathname === "/login" ? null : <Header />}
        {location.pathname !== "/login" && location.pathname !== "/patient-dashboard" && (
          <div className="flex-shrink-0">
            <SidebarComponent open={open} />
            <SearchPatientHeader />
          </div>
        )}
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<PrivateRoute component={MainPanel} />} />
          <Route path="/*" element={<NoPage />} />
          <Route
            path="/lab-center"
            element={<PrivateRoute component={LabCenter} />}
          />
          <Route
            path="/tox-report"
            element={<PrivateRoute component={ToxPage} />}
          />
          <Route
            path="/blood-report"
            element={<PrivateRoute component={BloodReport} />}
          />
          <Route
            path="/sti-report"
            element={<PrivateRoute component={StiReport} />}
          />
          <Route
            path="/lab-compilance"
            element={<PrivateRoute component={LabCompilance} />}
          />
          <Route
            path="/patient-list"
            element={<PrivateRoute component={PatientList} />}
          />
          <Route
            path="/patient-dashboard"
            element={<PrivateRoute component={PatientDashobard} />}
          />
        </Routes>
      </div>
    </div>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <AuthProvider>
    <LoadingProvider>
      <PatientDemographyProvider>
      <SearchResultsProvider>
        <BrowserRouter>
          <Spinner />
          <App />
          <ToastContainer />
        </BrowserRouter>
      </SearchResultsProvider>
      </PatientDemographyProvider>
    </LoadingProvider>
  </AuthProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
